import { ButtonEx, ButtonExProps } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { MinterAuctionContext, useGeotoken } from '../../Contexts'

const AuctionButton: React.FC<ButtonExProps> = (props) => {
  const { auction } = useContext(MinterAuctionContext)
  const geotoken = useGeotoken()

  const exists = !!auction
  const quadkey = auction?.quadkey ?? geotoken?.quadkey

  return (
    <ButtonEx disabled={!exists} to={`/auction/${quadkey?.toBase4HashLabel()}`} variant="outlined" {...props}>
      Auction
    </ButtonEx>
  )
}

export default AuctionButton
